import React from "react"
import { Row, Col, Form } from "react-bootstrap"
import { getIn } from "formik"
import {
  updateCategoryClaimData,
  formIsValidUpdate,
} from "../../../../Redux/WindscreenClaim/actions"
import { useDispatch, useSelector, shallowEqual } from "react-redux"
import FormLabel from "../../../shared/formLabel"

function FormRadioButtonClaimData({ ...props }) {
  const {
    textDesc,
    form,
    field,
    coverageCategory,
    coverageCode,
    // formIsValid,
    formName,
    extraFieldValue,
    affectedField,
  } = props

  const dispatch = useDispatch()
  const errors = getIn(form.errors, field.name)
  const touched = getIn(form.touched, field.name)

  const handleRadioButton = (buttonName, buttonValue) => {
    let actionList = []
    let denied = false
    actionList.push(
      updateCategoryClaimData(
        coverageCategory,
        coverageCode,
        buttonName,
        buttonValue
      )
    )
    form.setFieldValue(buttonName, buttonValue)

    let errorsList = form.errors

    if (extraFieldValue && affectedField) {
      if (extraFieldValue.indexOf(buttonValue) !== -1) {
        //!== -1 mean found in array
        denied = true
      }

      affectedField.forEach((FieldItem, FieldKey) => {
        delete errorsList[FieldItem]
        actionList.push(
          updateCategoryClaimData(coverageCategory, coverageCode, FieldItem, "")
        )
        form.setFieldValue(FieldItem, "")
      })

      if (
        Object.entries(errorsList).length === 0 && //Check form error list is empty
        !denied
      ) {
        actionList.push(formIsValidUpdate(formName, true))
      } else {
        actionList.push(formIsValidUpdate(formName, false))
      }
    }
    actionList.forEach((action, actionKey) => {
      dispatch(action)
    })

    form.resetForm()
    form.validateForm()
  }

  //Check if field exists in the state, if not, initialize
  const rdValue = useSelector(state => {
    if (!state.claimData[coverageCategory][coverageCode]) {
      state.claimData[coverageCategory][coverageCode] = {}
    }

    if (
      typeof state.claimData[coverageCategory][coverageCode][field.name] ==
      "undefined"
    ) {
      state.claimData[coverageCategory][coverageCode][field.name] = false
    }

    return state.claimData[coverageCategory][coverageCode][field.name]
  }, shallowEqual)

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col md={6} xs={12} className="marginTop10px">
          <Col
            md={5}
            xs={5}
            className={
              "font18 height50 horizontal-align backgroundGrey cursorPointer float-left borderRadius8 YesNobutton " +
              (rdValue ? "tick" : "")
            }
            onClick={event => {
              field.value = true
              handleRadioButton(field.name, field.value)
            }}
            role="button"
            //tabIndex="0"
          >
            <b>Yes</b>
          </Col>
          <Col
            md={5}
            xs={5}
            className={
              "font18 height50 horizontal-align backgroundGrey cursorPointer float-right borderRadius8 YesNobutton " +
              (!rdValue ? "tick" : "")
            }
            onClick={event => {
              field.value = false
              handleRadioButton(field.name, field.value)
            }}
            role="button"
            //tabIndex="0"
          >
            <b>No</b>
          </Col>
          {errors && touched && <span className="InputError">{errors}</span>}
        </Col>
      </Row>
    </Form.Group>
  )
}
export default FormRadioButtonClaimData
